import tr from '../JsonLang/tr.json'
export const lang = { ...tr }